/**
 * Created by Andrey Popov on 8/13/24.
 */

const Page = function (pageNo, offsetFromCenter) {
    this.pageNo = pageNo;
    this.comingSoon = cleverapps.meta.getSelectedLocation().getTotalStages() === pageNo;
    this.offsetFromCenter = offsetFromCenter;

    this.onAnimateClose = function () {};
    this.onAnimateOpen = function () {};
    this.onScroll = function () {};
};

Page.prototype.isComingSoon = function () {
    return this.comingSoon;
};

Page.prototype.isCurrent = function () {
    const location = cleverapps.meta.getSelectedLocation();
    return this.pageNo === location.getStage();
};

Page.prototype.isPassed = function () {
    const location = cleverapps.meta.getSelectedLocation();
    return this.pageNo < location.getStage();
};

Page.prototype.isOpened = function () {
    const location = cleverapps.meta.getSelectedLocation();
    return !(this.pageNo > location.getStage() || this.pageNo === location.getStage() && location.isCompleted());
};

Page.prototype.setOffsetFromCenter = function (offsetFromCenter) {
    this.offsetFromCenter = offsetFromCenter;
    this.onScroll();
};

Page.prototype.getResourcesBundleId = function () {
    return `page_${this.pageNo}_view_resources`;
};